import React from 'react';

import { useInView } from '../../hooks/useInView';
import type { HowItWorks } from './slides';

import './HowItWorksSection.css';

type HowItWorksSectionProps = {
    data: HowItWorks;
};

// Steps slide in left to right so the sequence reads in order. Slower than the
// usual stagger because the travel is sideways and further, so 80ms reads as a
// single blur rather than four steps.
const REVEAL_STEP_MS = 120;

export function HowItWorksSection({ data }: HowItWorksSectionProps) {
    const [ref, , revealed] = useInView<HTMLElement>();

    if (data.steps.length === 0) { return null; }

    return (
        <section
            ref={ref}
            className={`fb-hiw${revealed ? ' faves-reveal-group--in' : ''}`}
        >
            <div className="fb-hiw__header">
                <h2 className="fb-hiw__heading faves-display faves-reveal">{data.heading}</h2>
                <p className="fb-hiw__supporting faves-body faves-reveal">{data.supporting}</p>
            </div>
            <ol className="fb-hiw__steps">
                {data.steps.map((step, i) => (
                    <li
                        className="fb-hiw__step faves-reveal"
                        key={i}
                        style={{ '--reveal-delay': `${i * REVEAL_STEP_MS}ms` } as React.CSSProperties}
                    >
                        <span className="fb-hiw__number">{step.number}</span>
                        <h3 className="fb-hiw__title faves-h3">{step.title}</h3>
                        <p className="fb-hiw__body faves-body">{step.body}</p>
                    </li>
                ))}
            </ol>
        </section>
    );
}
